import { ErrorComponent } from './shared/pages/error-page/error-page.component';
import { Routes } from '@angular/router';
import { NotFoundComponent } from './shared/pages/not-found-page/not-found-page.component';
import { PrivateMainComponent } from './core/components/main/private/private-main.component';
import { NavRoutes } from './core/constants/nav.routes';
import { AuthorizedRole } from 'src/openapi-gen/models';
import { VerifyAccountComponent } from './core/components/verify-account/verify-account.component';
import { authGuard } from './auth/auth-guard.service';
import { PublicMainComponent } from './core/components/main/public/public-main.component';
import { KioskPageComponent } from './core/components/kiosk-page/kiosk-page.component';

export const APP_ROUTES: Routes = [
    {
        path: NavRoutes.Root,
        component: PublicMainComponent,
        children: [
            {
                path: NavRoutes.Root,
                loadChildren: () => import('./pages/about-us-page/about-us-page-routes').then(m => m.ROUTES),
            },
            { 
                path: NavRoutes.Root,
                loadChildren: () => import('./pages/sign-up-page/sign-up-page-routes').then(m => m.ROUTES),
            },
            { 
                path: NavRoutes.Root,
                loadChildren: () => import('./pages/forgot-password-page/forgot-password-page-routes').then(m => m.ROUTES),
            },
            {
                path: NavRoutes.Root,
                loadChildren: () => import('./pages/reset-password-page/reset-password-page-routes').then(m => m.ROUTES),
            },
            {
                path: NavRoutes.Root,
                loadChildren: () => import('./pages/contact-page/contact-page-routes').then(m => m.ROUTES),
            },
            { 
                path: NavRoutes.Root, 
                loadChildren: () => import('./pages/login-page/login-routes').then(m => m.ROUTES),
            }
        ]
    },
    {
        path: NavRoutes.Root,
        canActivate: [authGuard],
        data: { authorizedRoles: [AuthorizedRole.Any] },
        component: PrivateMainComponent,
        children: [
            {
                path: NavRoutes.Root,
                loadChildren: () => import('./pages/inventory-options/inventory-options-routes').then(m => m.ROUTES),
            },
            {
                path: NavRoutes.Root,
                loadChildren: () => import('./pages/change-password/change-password-routes').then(m => m.ROUTES),
            },
            {
                path: NavRoutes.Root,
                loadChildren: () => import('./pages/transaction-page/transaction-page-routes').then(m => m.ROUTES),
            },
            {
                path: NavRoutes.Root,
                loadChildren: () => import('./pages/dashboard-page/dashboard-page-routes').then(m => m.ROUTES),
            },
            {
                path: NavRoutes.Root,
                loadChildren: () => import('./pages/transaction-history-page/transaction-history-page-routes').then(m => m.ROUTES),
            },
            {
                path: NavRoutes.Root,
                loadChildren: () => import('./pages/product-management-page/product-management-page-routes').then(m => m.ROUTES),
            },
            {
                path: NavRoutes.Root,
                loadChildren: () => import('./pages/food-source-management-page/food-source-management-page-routes').then(m => m.ROUTES),
            },
            {
                path: NavRoutes.Root,
                loadChildren: () => import('./pages/agency-management-page/agency-management-page-routes').then(m => m.ROUTES),
            },
            {
                path: NavRoutes.Root,
                loadChildren: () => import('./pages/employee-management-page/employee-management-page-routes').then(m => m.ROUTES),
            },
            {
                path: NavRoutes.Root,
                loadChildren: () => import('./pages/employee-add-edit-page/employee-add-edit-page-routes').then(m => m.ROUTES),
            },
            {
                path: NavRoutes.Root,
                loadChildren: () => import('./pages/account-settings-page/account-settings-page-routes').then(m => m.ROUTES),
            },
            {
                path: NavRoutes.Root,
                loadChildren: () => import('./pages/inquiry-page/inquiry-page-routes').then(m => m.ROUTES),
            },
            {
                path: NavRoutes.Root,
                loadChildren: () => import('./pages/reference-number-management-page/reference-number-management-page-routes').then(m => m.ROUTES),
            },
        ]
    },
    {
        path: NavRoutes.Root,
        canActivate: [authGuard],
        data: { authorizedRoles: [AuthorizedRole.Any] },
        component: KioskPageComponent,
        children: [
            { 
                path: NavRoutes.Root,
                loadChildren: () => import('./pages/kiosk-scan-page/kiosk-scan-page-routes').then(m => m.ROUTES), 
            },
            { 
                path: NavRoutes.Kiosk, 
                loadChildren: () => import('./pages/kiosk-options/kiosk-options-routes').then(m => m.ROUTES), 
            },
            {
                path: NavRoutes.Kiosk,
                loadChildren: () => import('./pages/inventory-options/inventory-options-routes').then(m => m.ROUTES),
            },
            {
                path: NavRoutes.Kiosk,
                loadChildren: () => import('./pages/transaction-page/transaction-page-routes').then(m => m.ROUTES),
            }
        ]
    },
    { path: NavRoutes.VerifyAccount, component: VerifyAccountComponent, pathMatch: 'full' },

    { path: NavRoutes.Error, component: ErrorComponent },
    { path: '**', component: NotFoundComponent },
];